import { useState } from "react";

export type HomeView = "salon" | "me";

// A manager's last choice of home view, per signed-in phone on this device. `stored` is null until they
// have picked once.
export default function useHomeView(phone: string) {
  const key = `home-view:${phone}`;
  const [stored, setStored] = useState<HomeView | null>(() => {
    try {
      const value = localStorage.getItem(key);
      return value === "salon" || value === "me" ? value : null;
    } catch {
      return null;
    }
  });
  const choose = (view: HomeView) => {
    try {
      localStorage.setItem(key, view);
    } catch {
      // Storage unavailable: the choice still applies until reload.
    }
    setStored(view);
  };
  return { view: stored ?? "salon", stored, choose };
}
